import { useContext, useRef } from "react";
import Slider from "react-slick";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import categoriesContext from "../../../dataManager/context/categoriesContext";
import CategoryCard from "../../marketing/pageSections/components/CategoryCard";
import LoaderCard from "../../utils/loadersBox/LoaderCard";

import "../../../css/categoryProductCarousel.css";

const CategoryProductsCarousel = ({ classe }) => {
  const { categories } = useContext(categoriesContext);

  // ref the slider
  const slider = useRef(null);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const allLoadersCards = [1, 2, 3, 4, 5].map((arg) => (
    <LoaderCard isCategory={true} />
  ));

  const allCategoriesCards = categories.map((category) => (
    <CategoryCard key={category.getId} category={category} />
  ));

  return (
    <div className="categoryProducts relative mt-10  md:mt-16">
      <Slider
        {...settings}
        ref={slider}
        className="flex space-y-4 md:space-x-3"
      >
        {categories.length > 0 ? allCategoriesCards : allLoadersCards}
      </Slider>
      <SamplePrevArrow slider={slider} />
      <SampleNextArrow slider={slider} />
    </div>
  );
};

function SampleNextArrow({ slider }) {
  return (
    <button
      onClick={() => slider?.current?.slickNext()}
      className="absolute right-0 top-[50%] z-20 h-16 w-6 translate-y-[-50%] rounded-r-md bg-secondary"
    >
      <MdKeyboardArrowRight
        color="#C6C5C9"
        size={30}
        className="mx-auto my-auto"
      />
    </button>
  );
}

function SamplePrevArrow({ slider }) {
  return (
    <button
      onClick={() => slider?.current?.slickPrev()}
      className="letf-0 absolute top-[50%] z-20 h-16 w-6 translate-y-[-50%] rounded-l-md bg-secondary"
    >
      <MdKeyboardArrowLeft
        color="#C6C5C9"
        size={30}
        className="mx-auto my-auto"
      />
    </button>
  );
}

export default CategoryProductsCarousel;
